import React from 'react';
import styled from 'styled-components';
import { LandPlot, Triangle } from 'lucide-react';

const Badge = styled.div`
  display: inline-flex;
  align-items: center;
  white-space: nowrap;
  gap: 0.4rem;
  padding: 0.3rem 0.6rem;
  border-radius: 999px;
  font-size: ${props => props.$style?.fontSize || '0.875rem'};
  font-weight: 500;
  background: ${({ $eventType }) => {
    switch ($eventType) {
      case 'WeGo':
        return '#f0fdf4'; // Light green background
      case 'TLG':
        return '#fef3c7'; // Light yellow background
      default:
        return '#f3f4f6';
    }
  }};
  color: ${({ $eventType }) => {
    switch ($eventType) {
      case 'WeGo':
        return '#166534'; // Dark green text
      case 'TLG':
        return '#92400e'; // Dark yellow text
      default:
        return '#374151';
    }
  }};
  border: 1px solid ${({ $eventType }) => {
    switch ($eventType) {
      case 'WeGo':
        return '#34d399'; // Green border
      case 'TLG':
        return '#fbbf24'; // Yellow border
      default:
        return '#e5e7eb';
    }
  }};
`;

const EventTypeBadge = ({ eventType, iconSize = 16, style = {}, icon = true }) => {
  const getIcon = () => {
    switch (eventType) {
      case 'WeGo':
        return <LandPlot size={iconSize} />;
      case 'TLG':
        return <Triangle size={iconSize} />;
      default:
        return null;
    }
  };

  return (
    <Badge 
      $eventType={eventType} 
      $style={style}
    >
      {icon && getIcon()}
      {eventType}
    </Badge>
  );
};

export default EventTypeBadge;